import { render, staticRenderFns } from "./ChildStoryContributor.vue?vue&type=template&id=2bd5d914&scoped=true&"
import script from "./ChildStoryContributor.vue?vue&type=script&lang=js&"
export * from "./ChildStoryContributor.vue?vue&type=script&lang=js&"
import style0 from "./ChildStoryContributor.vue?vue&type=style&index=0&id=2bd5d914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd5d914",
  null
  
)

export default component.exports